<template>
  <IframeCmp type="115" />
</template>

<script>
import IframeCmp from './cmp/IframeCmp';

export default {
  // 财务应收看板-总览
  name: 'DailyCollectionReceivableReportIndex',
  components: {
    IframeCmp
  },
  data() {
    return {

    };
  }
};
</script>

<style scoped></style>
